import { HttpAxiosRequest } from 'src/http/httpAxiosBase';
import { BaseResponse } from 'src/types';
import { SistemaTipo } from "../../../../../types/enum/enum";
import { HttpOperacionInforme } from "../../../api/httpOperacionInforme";
import {
  OperacionADLInsert,
  schemaOperacionADLInsert
} from '../types/dto';
import { OperacionADL, schemaOperacionADL } from '../types/types';
import { FilePutFields } from 'src/pages/sistema/api/file-fields';

export const getEndpoint = (url = '') => `operaciones/adl${url}`;

export const HttpADL = {
  get: (idOperacion: number): Promise<OperacionADL> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
      .then(response => {
        const parsed = schemaOperacionADL.safeParse(response);

        if (!parsed.success) {
          console.error('Validation Error (HttpADL.get):', parsed.error.issues);
          
return Promise.reject(new Error('Validation error.'));
        }

        return parsed.data;
      })
      .catch(error => {
        console.error('Network Error (HttpADL.get):', error);
        
return Promise.reject(new Error('Error obteniendo operación ADL.'));
      });
  },

  post: (operacion: OperacionADLInsert): Promise<BaseResponse> => {
    const parsed = schemaOperacionADLInsert.safeParse(operacion);

    if (!parsed.success) {
      console.error('Validation Error (HttpADL.post):', parsed.error.issues);
      
return Promise.reject(new Error('Validation error.'));
    }

    const formData = new FormData();
    formData.append('operacionInsertarJson', JSON.stringify(parsed.data));

    const archivo = (operacion as any)[FilePutFields.File];
    if (archivo) {
      formData.append('file', archivo);
    }

    return HttpAxiosRequest.post(getEndpoint(), formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        console.error('Network Error (HttpADL.post):', error);
        
return Promise.reject(new Error('Error insertando operación ADL.'));
      });
  },

  descargarInforme: (idOperacion: number): Promise<any> =>
    HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.ADL),

  getArchivoAdjunto: (idOperacion: number): Promise<any> =>
    HttpAxiosRequest.getBlob(
      getEndpoint(`/${idOperacion}/archivos/adjunto`)
    ),

} as const;